import React from 'react'
import {
    StyledAppDownloadSubText,
    StyledAppDownloadTitle,
} from '../../components/StyledAppDownloadText.styled'
import { TNAppDownloadButtons } from '../TNAppDownloadButtons/TNAppDownloadButtons'
import {
    AppDownloadButtonsSection,
    AppDownloadContentSectionTop,
    InnerAppDownloadTextSectionTop,
    StyledAppDownloadSectionTop
} from './TNAppDownloadSectionTop.styled'

export function TNAppDownloadSectionTop() {
    return (
        <StyledAppDownloadSectionTop>
            <AppDownloadContentSectionTop>
                <InnerAppDownloadTextSectionTop>
                    <StyledAppDownloadTitle>
                        Get The Nightly App.
                    </StyledAppDownloadTitle>
                    <StyledAppDownloadSubText>
                        Get the most out of you news with the FREE Nightly app. Available for iOS and Android.
                    </StyledAppDownloadSubText>
                </InnerAppDownloadTextSectionTop>
                <AppDownloadButtonsSection>
                    <TNAppDownloadButtons />
                </AppDownloadButtonsSection>
            </AppDownloadContentSectionTop>
        </StyledAppDownloadSectionTop>
    )
}
